export function getBaseCrumbs({ categories, categoryUrl }) {
    const crumbs = [{ label: 'Home', url: '/' }];
  
    if (!categories || !categoryUrl) return crumbs;
  
    // Recursive helper to find the breadcrumb path
    function findCategoryPath(nodes, targetUrl, parentPath = '') {
      for (const node of nodes) {
        const currentUrl = `${node.url}`;
  
        if (node.url === targetUrl) {
          return [{ label: node.title ?? '', url: currentUrl }];
        }
  
        if (Array.isArray(node.subCategories) && node.subCategories.length > 0) {
          const subPath = findCategoryPath(node.subCategories, targetUrl, currentUrl);
  
          if (subPath.length > 0) {
            return [{ label: node.title ?? '', url: currentUrl }, ...subPath];
          }
        }
      }
  
      return [];
    }
  
    const path = findCategoryPath(categories, categoryUrl);
    return [...crumbs, ...path];
  }
  